const API_URL = process.env.REACT_APP_API_URL;
const LEGACY_FAST_API_URL = process.env.REACT_APP_FAST_API_URL || "";
// Realtime editor traffic goes to the versioned compatibility router on the
// same FastAPI host. This is intentionally code-owned: missing a build-time
// env var must not silently disable ru_ru -> ru_* synchronisation.
export const STREAM_FAST_API_URL = "https://fastapi.dev.torsunov.pro";

// All /fast clients import this live binding. It is selected before the first
// editor request, so lectures keep their legacy backend untouched.
export let FAST_API_URL = LEGACY_FAST_API_URL;
let resolveGeneration = 0;

export const resolveFastApiForMedia = async (mediaId: string): Promise<boolean> => {
  const generation = ++resolveGeneration;
  FAST_API_URL = LEGACY_FAST_API_URL;
  if (!mediaId) return false;
  try {
    const base = STREAM_FAST_API_URL.replace(/\/$/, "");
    const response = await fetch(`${base}/stream_editor/v1/session?media=${encodeURIComponent(mediaId)}`);
    if (!response.ok) return false;
    const session = await response.json();
    if (!session?.is_realtime_stream) return false;
    if (generation !== resolveGeneration) return false;
    FAST_API_URL = `${base}/stream_editor/v1`;
    return true;
  } catch {
    return false;
  }
};
export const SITE_SERVER_URL = process.env.REACT_APP_SITE_SERVER_URL;

export const postOptions = {
  method: "POST",
  mode: "cors" as const,
  cache: "no-cache" as const,
  credentials: "same-origin" as const,
  headers: {
    "Content-Type": "application/json",
  },
  redirect: "follow" as const,
  referrerPolicy: "no-referrer" as const,
};

export const segmentsToKeep = async (mediaId: string, json: Object) => {
  try {
    const response = await fetch(`${API_URL}/segments_to_keep?media=${mediaId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Segments to keep response:", data);
    /*fetchTracks(mediaId, () => {

      })*/

    return data;
  } catch (error) {
    console.error("Error segments to keep call:", error);
    throw error;
  }
};
